import { HttpStatusCode } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { AppError, ErrorsInterceptor } from '@hglobal/fin-ui';

import { RouterStore } from '@kr/core';
import { AuthService } from '@kr/store';

/**
 * App Errors interceptor
 */
@Injectable()
export class AppErrorsInterceptor extends ErrorsInterceptor {
  readonly #auth = inject(AuthService);
  readonly #routerStore = inject(RouterStore);
  override codeField = 'errorCode';
  override messageField = 'errorDescription';
  override dataField = 'data';

  override beforeThrowing(error: AppError): AppError {
    const { pathname } = window.location;

    const ignoreList = ['signin', '/'];
    const ignore = ignoreList.some(item => pathname.includes(item));

    if (error.originalError?.status === HttpStatusCode.Unauthorized && !ignore) {
      this.#auth.logout();
    }

    if (error.originalError?.status === HttpStatusCode.NotFound) {
      this.#routerStore.navigateTo404();
    }

    return error;
  }
}
